import React, { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { tt } from '@i18n/tt';
import { Button, Divider, Typography } from '@mui/material';

import { useAppDispatch, useAppSelector } from 'store/hooks';
import { PortalConfigSelector } from 'store/config/selectors';
import { UserDataSelector } from 'store/user/selector';
import { logOutUser } from 'store/auth';

import Action from 'components/Action';
import Notifications from './Notifications';
import TechnicianData from './TechnicianData';
import TechnicianVerification from './TechnicianVerification';
import ThemeSwitch from 'components/Layout/components/ThemeSwitch';
import UISwitch from 'components/Layout/components/UISwitch';

import { ReactComponent as LeaveIcon } from 'assets/leave.icon.svg';
import { PROFILE } from 'router/routes';

import useStyles from '../styles';

const AppBarComponent: FC = () => {
  const { contactName } = useAppSelector(UserDataSelector);
  const { caption } = useAppSelector(PortalConfigSelector);

  const dispatch = useAppDispatch();
  const classes = useStyles();
  const navigate = useNavigate();

  const handleLogOut = useCallback(() => {
    dispatch(logOutUser({}));
  }, [dispatch]);

  return (
    <div className={classes.appBar}>
      <div className={classes.captionContainer}>
        <Typography fontSize='28px' fontWeight={700}>{caption}</Typography>
      </div>

      <div className={classes.contactName}>
        <UISwitch />
        <ThemeSwitch />
        <Divider orientation="vertical" />
        <TechnicianVerification />
        <TechnicianData />
        <Notifications />
        <Divider orientation="vertical" />
        <Button
          variant="text"
          type="button"
          onClick={() => {
            navigate(PROFILE);
          }}
          className={classes.button}
        >
          {contactName}
        </Button>
        <Action tooltip={tt('common.logout')} onClick={handleLogOut} icon={<LeaveIcon />} />
      </div>
    </div>
  );
};

export default AppBarComponent;
